import { render, staticRenderFns } from "./EmployeeView.vue?vue&type=template&id=a4a1e8de&scoped=true"
import script from "./EmployeeView.vue?vue&type=script&setup=true&lang=js"
export * from "./EmployeeView.vue?vue&type=script&setup=true&lang=js"
import style0 from "./EmployeeView.vue?vue&type=style&index=0&id=a4a1e8de&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4a1e8de",
  null
  
)

export default component.exports